export const STATE_TRANSLATIONS = {
    en: {
        label: 'State',
        requiredMessage: "This field is required."
    },
    en_BR: {
        label: "Estado"
    },
    en_CA: {
        label: 'Province'
    },
    en_ID: {
        label: "Province"
    },
    en_PE: {
        label: 'Region'
    },
    en_RU: {
        label: "Region"
    },
    en_UA: {
        label: "Region"
    },
    en_VN: {
        label: "Province"
    },
    en_ZA: {
        label: 'Province'
    },
    es: {
        label: 'Estado',
        requiredMessage: 'Este campo es obligatorio'
    },
    es_AR: {
        label: "Provincia"
    },
    es_CA: {
        label: 'Provincia'
    },
    es_CL: {
        label: "Provincia"
    },
    es_CO: {
        label: "Departamento",
        requiredMessage: "Este campo es requerido"
    },
    es_CR: {
        label: "Provinces"
    },
    es_GT: {
        label: "Departments"
    },
    es_HN: {
        label: "Departments"
    },
    es_PE: {
        label: 'Departamento'
    },
    es_SV: {
        label: "Departments"
    },
    es_VE: {
        requiredMessage: "Es una área requeria"
    },
    es_ZA: {
        label: 'Provincia'
    },
    fr: {
        label: "Province",
        requiredMessage: "Ceci est un champ obligatoire."
    },
    in: {
        label: "Province",
        requiredMessage: "This field is required."
    },
    ja: {
        label: "都道府県：",
        requiredMessage: "この項目は必須です。"
    },
    ms: {
        label: "State",
        requiredMessage: "This field is required."
    },
    pt: {
        label: "Estado",
        requiredMessage: "Campo é obrigatório"
    },
    ru: {
        label: "область",
        requiredMessage: "Это поле обязательно для заполнения."
    },
    ru_UA: {
        label: "Область"
    },
    uk: {
        label: "Область",
        requiredMessage: "Це поле є обов язковим для заповнення."
    },
    vi: {
        label: "Tiểu bang",
        requiredMessage: "Trường thông tin bắt buộc"
    },
    vi_VN: {
        label: "Tỉnh/Thành Phố"
    },
    zh: {
        label: '州'
    },
    zh_CA: {
        label: '省'
    },
    zh_ZA: {
        label: '省'
    }
};
